import { UPDATE_SEARCHTDATA_CHIDELETE } from "../../actions/DanhSachChiDelete/actionTypes";

const initialState = {
  name: "",
  dateFrom: "01/01/2001",
  dateTo: "01/01/4000",
  NguoiXoa: "",
  page: 1,
  pageSize: 25,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchChiDelete = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_CHIDELETE:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchChiDelete;
